<div>
  <sh-text size="title-1" color="secondary">
    {{ labelStatusHeader }}
  </sh-text>

  <div *ngIf="lastDataSourceRefreshState; else noInformation">
    <div *ngIf="lastDataSourceRefreshState?.updatedSince" class="item-group">
      <div class="item" [attr.hideLastUpdate]="hideLastUpdate || undefined">
        <sh-text
          size="body-2"
          color="secondary"
          *ngIf="lastPatternHeader !== undefined"
          class="text-wrap-enable"
        >
          {{ lastPatternHeader }}:
        </sh-text>
        <sh-text
          size="body-2"
          color="primary"
          *ngIf="lastPatternHeader !== undefined"
          class="text-wrap-enable"
        >
          {{
            lastDataSourceRefreshState?.updatedPatternSince
              | timeFromNow: 'unknown'
          }}
        </sh-text>
      </div>
    </div>

    <div *ngIf="lastDataSourceRefreshState.linkToXmart?.length >= 10">
      <app-linkToXmart
        [xmartSummaryLink]="lastDataSourceRefreshState.linkToXmart"
      ></app-linkToXmart>
    </div>
  </div>

  <ng-template #noInformation>
    <div columns="12" class="display-text">
      <div>
        <sh-text
          columns="6"
          size="body-2"
          color="secondary"
          *ngIf="lastUpdateHeader !== undefined"
        >
          {{ lastUpdateHeader }}:
        </sh-text>
        <sh-text
          columns="6"
          size="body-2"
          color="primary"
          *ngIf="lastUpdateHeader !== undefined"
        >
          {{ 'label.lastDataSourceRefresh.noInformation' | translate }}
        </sh-text>
      </div>
      <div>
        <sh-text
          columns="6"
          size="body-2"
          color="secondary"
          *ngIf="lastPatternHeader !== undefined"
        >
          {{ lastPatternHeader }}:
        </sh-text>
        <sh-text
          columns="6"
          size="body-2"
          color="primary"
          *ngIf="lastUpdateHeader !== undefined"
        >
          {{ 'label.lastDataSourceRefresh.noInformation' | translate }}
        </sh-text>
      </div>
    </div>
  </ng-template>
</div>
